import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "combine-order-comfirm__section combine-order-comfirm__section--setting" }
const _hoisted_2 = { class: "section-title" }
const _hoisted_3 = { class: "setting__input__label" }
const _hoisted_4 = {
  for: "combine-order-confirm-input-group",
  class: "setting__input__label-text"
}
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "setting__info" }
const _hoisted_7 = { class: "setting__info-item" }
const _hoisted_8 = { class: "setting__info-text setting__info-text--label" }
const _hoisted_9 = { class: "setting__info-text setting__info-text--value" }
const _hoisted_10 = { class: "setting__info-item" }
const _hoisted_11 = { class: "setting__info-text setting__info-text--label" }
const _hoisted_12 = { class: "setting__info-text setting__info-text--value" }
const _hoisted_13 = { class: "setting__info-item" }
const _hoisted_14 = { class: "setting__info-text setting__info-text--label" }
const _hoisted_15 = { class: "setting__info-text setting__info-text--value" }
const _hoisted_16 = { class: "setting__info-item" }
const _hoisted_17 = { class: "setting__info-text setting__info-text--label" }
const _hoisted_18 = { class: "setting__info-text setting__info-text--value" }
const _hoisted_19 = { class: "combine-order-comfirm__section combine-order-comfirm__section--detail" }
const _hoisted_20 = { class: "section-title" }
const _hoisted_21 = { class: "detail__table-header-data" }
const _hoisted_22 = { class: "detail__table-header-data" }
const _hoisted_23 = { class: "detail__table-header-data" }
const _hoisted_24 = { class: "detail__table-header-data" }
const _hoisted_25 = { class: "detail__table-header-data" }
const _hoisted_26 = { class: "detail__table-header-data" }
const _hoisted_27 = { class: "detail__table-header-data detail__table-header-data--unit" }
const _hoisted_28 = { class: "detail__table-header-data" }

import { DateService } from '@/coreDomainsModule/services/dateService';
import EzCell from '@/corePagesModule/components/ezTable/EzCell.vue';
import EzHeader from '@/corePagesModule/components/ezTable/EzHeader.vue';
import EzTable from '@/corePagesModule/components/ezTable/EzTable.vue';
import EzTableRow from '@/corePagesModule/components/ezTable/EzTableRow.vue';
import InfoModal from '@/corePagesModule/components/InfoModal.vue';
import { i18n } from '@/i18n';
import { useInventoryStore } from '@/InventoryControlModule/pages/useInventoryStore';
import { storeToRefs } from 'pinia';


export default /*@__PURE__*/_defineComponent({
  __name: 'CombineOrderConfirmModal',
  setup(__props) {

const t = i18n.t;
const inventoryStore = useInventoryStore();
const { state } = storeToRefs(inventoryStore);
const { resetCombinedOrderStatus, onConfirmCombinedOrder } = inventoryStore;

const gridTemplateColumns: string[] = ['125px', '125px', '125px', '125px', '125px', '125px', '80px', '125px'];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InfoModal, {
    "back-button-label": _unref(t)('キャンセル'),
    "next-button-label": _unref(t)('まとめ発注確定'),
    "modal-state": !!_unref(state).combinedOrdersState.combinedOrderContents.orderCount,
    "modal-width": 1024,
    "is-disabled-next-button": _unref(state).combinedOrdersState.combinedOrderContents.groupName === '',
    "no-description": "",
    class: "combine-order-comfirm",
    onOnBack: _unref(resetCombinedOrderStatus),
    onOnNext: _unref(onConfirmCombinedOrder)
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)('まとめ発注内容確認')), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h2", _hoisted_2, _toDisplayString(_unref(t)('まとめ発注グループ設定')), 1),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("label", _hoisted_4, _toDisplayString(_unref(t)('グループ名')) + "*", 1)
          ]),
          _createElementVNode("input", {
            id: "combine-order-confirm-input-group",
            class: "setting__input",
            type: "text",
            value: _unref(state).combinedOrdersState.combinedOrderContents.groupName,
            onInput: _cache[0] || (_cache[0] = 
              (e) => {
                _unref(state).combinedOrdersState.combinedOrderContents.groupName = (e.target as HTMLInputElement).value;
              }
            )
          }, null, 40, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(t)('発注件数')), 1),
            _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(state).combinedOrdersState.combinedOrderContents.orderCount), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(t)('発注合計数量')), 1),
            _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(state).combinedOrdersState.combinedOrderContents.totalAmount.addComma()), 1)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(t)('希望納期')), 1),
            _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(DateService).convertIYearMonthDayToYYYYMMDDWithSlash(
                  _unref(state).combinedOrdersState.combinedOrderContents.desiredDeliveryDate,
                  true
                )), 1)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(t)('積載率')), 1),
            _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(state).combinedOrdersState.combinedOrderContents.loadFactor.roundToDecimal(2).addComma()) + "% ", 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("h2", _hoisted_20, _toDisplayString(_unref(t)('発注詳細')), 1),
        _createVNode(EzTable, {
          "grid-template-columns": gridTemplateColumns,
          "max-height": "325px",
          "sticky-header": "",
          class: "detail__table"
        }, {
          header: _withCtx(() => [
            _createVNode(EzHeader, { class: "detail__table-header" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(t)('置場コード')), 1)
              ], undefined, true),
              _: 1
            }),
            _createVNode(EzHeader, { class: "detail__table-header" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(t)('置場名')), 1)
              ], undefined, true),
              _: 1
            }),
            _createVNode(EzHeader, { class: "detail__table-header" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_23, _toDisplayString(_unref(t)('仕入先コード')), 1)
              ], undefined, true),
              _: 1
            }),
            _createVNode(EzHeader, { class: "detail__table-header" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_24, _toDisplayString(_unref(t)('仕入先名')), 1)
              ], undefined, true),
              _: 1
            }),
            _createVNode(EzHeader, { class: "detail__table-header" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_25, _toDisplayString(_unref(t)('商品コード')), 1)
              ], undefined, true),
              _: 1
            }),
            _createVNode(EzHeader, { class: "detail__table-header" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_26, _toDisplayString(_unref(t)('商品名')), 1)
              ], undefined, true),
              _: 1
            }),
            _createVNode(EzHeader, { class: "detail__table-header" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_27, _toDisplayString(_unref(t)('容量')), 1)
              ], undefined, true),
              _: 1
            }),
            _createVNode(EzHeader, { class: "detail__table-header" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_28, _toDisplayString(_unref(t)('発注数量')), 1)
              ], undefined, true),
              _: 1
            })
          ]),
          body: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).combinedOrdersState.combinedOrderContents.confirmedOrdersWithBusinessAndAdjustment, (orderWithBusiness, index) => {
              return (_openBlock(), _createBlock(EzTableRow, {
                id: `combine-order-confirm-table-row-${index}`,
                key: orderWithBusiness.business.businessId,
                "grid-template-columns": gridTemplateColumns,
                class: "detail__table-row"
              }, {
                default: _withCtx(() => [
                  _createVNode(EzCell, { class: "detail__table-data" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(orderWithBusiness.business.warehouseNumber), 1)
                    ], undefined, true),
                    _: 2
                  }, 1024),
                  _createVNode(EzCell, { class: "detail__table-data" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(orderWithBusiness.business.warehouse), 1)
                    ], undefined, true),
                    _: 2
                  }, 1024),
                  _createVNode(EzCell, { class: "detail__table-data" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(orderWithBusiness.business.supplierNumber), 1)
                    ], undefined, true),
                    _: 2
                  }, 1024),
                  _createVNode(EzCell, { class: "detail__table-data" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(orderWithBusiness.business.supplierName), 1)
                    ], undefined, true),
                    _: 2
                  }, 1024),
                  _createVNode(EzCell, { class: "detail__table-data" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(orderWithBusiness.business.businessNumber), 1)
                    ], undefined, true),
                    _: 2
                  }, 1024),
                  _createVNode(EzCell, { class: "detail__table-data" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(orderWithBusiness.business.businessName), 1)
                    ], undefined, true),
                    _: 2
                  }, 1024),
                  _createVNode(EzCell, {
                    "force-right": "",
                    class: "detail__table-data"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(orderWithBusiness.business.package), 1)
                    ], undefined, true),
                    _: 2
                  }, 1024),
                  _createVNode(EzCell, {
                    "force-right": "",
                    class: "detail__table-data"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(orderWithBusiness.order.amount.addComma()), 1)
                    ], undefined, true),
                    _: 2
                  }, 1024)
                ], undefined, true),
                _: 2
              }, 1032, ["id"]))
            }), 128))
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["back-button-label", "next-button-label", "modal-state", "is-disabled-next-button", "onOnBack", "onOnNext"]))
}
}

})